const reportOnlineId = {
	report_online: {
		title: "Laporan Toko Online",
		subtitle: "Ringkasan penjualan dan keuangan",
		tabs: {
			summary: "Ringkasan",
			sales: "Penjualan",
			product: "Penjualan Per Produk",
			customer: "Penjualan Per Pelanggan",
		},
		filters: {
			store: "Toko",
			all_stores: "Semua Toko",
			status: "Status",
			all_statuses: "Semua Status",
		},
		summary: {
			title: "Laporan Toko Online",
			subtitle: "Ringkasan penjualan dan keuangan online",
			all_stores: "Semua Toko",
			loading_partner: "Loading partner info...",
			loading: "Loading...",
			empty: "Tidak ada data",
			cards: {
				income: "Penerimaan",
				expense: "Pengeluaran",
				summary: "Ringkasan",
			},
			income: {
				cash: "Pembayaran Tunai",
				non_cash: "Pembayaran Non Tunai",
				shipping: "Ongkos Kirim",
				total: "Total Penerimaan",
			},
			expense: {
				fee_mdr: "Fee (MDR)",
				commission: "Komisi",
				total: "Total Pengeluaran",
			},
			totals: {
				net_income: "Pendapatan Bersih",
				hpp: "Harga Pembelian (HPP)",
				shipping: "Ongkos Kirim",
				pnl: "Laba/Rugi",
			},
		},
		sales: {
			title: "Data Penjualan",
			empty_state: {
				title: "Tidak ada data penjualan",
				description: "Belum ada transaksi penjualan pada periode ini.",
			},
			summary_stats: {
				qty: "Qty Penjualan",
				total: "Total Penjualan",
				order_unit: "order",
			},
			columns: {
				invoice_id: "Invoice ID",
				date: "Tanggal",
				payment_method: "Metode Pembayaran",
				customer: "Pelanggan",
				payment_amount: "Jml. Pembayaran",
				discount: "Disc.",
				shipping_method: "Metode Pengiriman",
				shipping_cost: "Ongkir",
				resi: "Resi/Kurir",
				status: "Status",
			},
			status: {
				success: "Success",
				confirm: "Confirm",
				pending: "Pending",
				shipping: "Shipping",
				canceled: "Canceled",
			},
		},
		product: {
			title: "Data Penjualan Per Produk",
			empty_state: {
				title: "Tidak ada data penjualan produk",
				description: "Belum ada penjualan produk pada periode ini.",
			},
			summary_stats: {
				total_qty: "Total Qty Terjual",
				total: "Total Penjualan",
				item_unit: "item",
			},
			columns: {
				category: "Kategori",
				product: "Produk",
				variant: "Varian",
				sold: "Terjual",
				total: "Total",
			},
		},
		customer: {
			title: "Data Penjualan Per Pelanggan",
			empty_state: {
				title: "Tidak ada data pelanggan",
				description: "Belum ada transaksi pelanggan pada periode ini.",
			},
			columns: {
				name: "Nama",
				phone: "Nomor Handphone",
				email: "Email",
				qty: "Qty Pembelian",
				total: "Total Pembelian",
			},
		},
		modals: {
			sales: {
				title: "Detail Penjualan",
				sections: {
					sales_info: "Informasi Penjualan",
					customer_store: "Informasi Pelanggan & Toko",
					shipping: "Informasi Pengiriman",
				},
				fields: {
					invoice_id: "Invoice ID",
					date: "Tanggal",
					total_payment: "Total Pembayaran",
					payment_method: "Metode Pembayaran",
					discount: "Diskon",
					status: "Status",
					customer: "Pelanggan",
					store: "Toko",
					shipping_method: "Metode Pengiriman",
					shipping_cost: "Ongkos Kirim",
					resi: "Resi/Kurir",
				},
				close: "Tutup",
			},
			product: {
				title: "Detail Produk",
				sections: {
					product_info: "Informasi Produk",
					sales_info: "Informasi Penjualan",
				},
				fields: {
					product_name: "Nama Produk",
					category: "Kategori",
					variant: "Varian",
					sold_qty: "Jumlah Terjual",
					total: "Total Penjualan",
				},
				unit: "pcs",
				close: "Tutup",
			},
		},
	},
};

export default reportOnlineId;
